__turbopack_context__.v({
  "banner": "PasswordlessLogin-module__8uwccW__banner",
  "codeInput": "PasswordlessLogin-module__8uwccW__codeInput",
  "fields": "PasswordlessLogin-module__8uwccW__fields",
  "footer": "PasswordlessLogin-module__8uwccW__footer",
  "footerContent": "PasswordlessLogin-module__8uwccW__footerContent",
  "resendButton": "PasswordlessLogin-module__8uwccW__resendButton",
  "root": "PasswordlessLogin-module__8uwccW__root",
});
